import { Injectable, OnDestroy } from '@angular/core';

import { BroadcastChannel, LeaderElector, createLeaderElection } from 'broadcast-channel';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AvTelemetryTabGuardService implements OnDestroy {
  static readonly CHANNEL_NAME = 'av-telemetry';

  private channel: BroadcastChannel<never> | null = null;
  private elector: LeaderElector | null = null;
  private readonly isLeaderSubject = new BehaviorSubject<boolean>(false);

  readonly isTelemetryLeader$: Observable<boolean> = this.isLeaderSubject.asObservable();

  get isLeader(): boolean {
    return this.isLeaderSubject.value;
  }

  ngOnDestroy(): void {
    void this.stop();
  }

  start(): void {
    if (this.channel && !this.channel.isClosed) {
      return;
    }

    this.channel = this.createChannel();
    this.elector = this.createElector(this.channel);

    void this.elector.awaitLeadership().then(() => {
      if (this.elector && !this.elector.isDead) {
        this.isLeaderSubject.next(true);
      }
    });
  }

  async stop(): Promise<void> {
    this.isLeaderSubject.next(false);

    const elector = this.elector;
    const channel = this.channel;
    this.elector = null;
    this.channel = null;

    await elector?.die();
    await channel?.close();
  }

  protected createChannel(): BroadcastChannel<never> {
    return new BroadcastChannel<never>(AvTelemetryTabGuardService.CHANNEL_NAME);
  }

  protected createElector(channel: BroadcastChannel<never>): LeaderElector {
    return createLeaderElection(channel);
  }
}
